var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * BulkContainerModal
 * Modal for bulk carton/container creation.
 * Creates N containers each with M quantity of a single product.
 * Allows packing into an existing open container, or creating a new parent with containerTypeEnumId=CtPallet on the fly.
 */
import React, { useCallback, useEffect, useImperativeHandle, useMemo, useRef, useState, forwardRef } from 'react';
import { Form, Modal, } from 'antd';
import { useTranslation } from 'react-i18next';
import Input from '@fp-suite/core-ui/src/components/Input';
import Dropdown from '@fp-suite/core-ui/src/components/Dropdown';
/**
 * Disallow subcontainers of anytype but carton & casepack
 */
var ALLOWED_CONTAINER_ENUM_IDS = ['CtCarton', 'CtCasePack'];
export var BulkContainerModal = forwardRef(function (_a, ref) {
    var visible = _a.visible, _b = _a.loading, loading = _b === void 0 ? false : _b, selectedContainerId = _a.selectedContainerId, _c = _a.containerTypeList, _containerTypeList = _c === void 0 ? [] : _c, onClose = _a.onClose, onSubmit = _a.onSubmit;
    var t = useTranslation().t;
    var form = Form.useForm()[0];
    var scanInputRef = useRef(null);
    var _d = useState(false), isSubmitting = _d[0], setIsSubmitting = _d[1];
    var _e = useState('new'), packIntoMode = _e[0], setPackIntoMode = _e[1];
    var isConfirmLoading = loading || isSubmitting;
    var pendingPrefill = useRef(null);
    useImperativeHandle(ref, function () { return ({
        prefill: function (params) {
            pendingPrefill.current = params;
        }
    }); }, []);
    var containerTypeList = useMemo(function () {
        return _containerTypeList.filter(function (it) { return ALLOWED_CONTAINER_ENUM_IDS.includes(it.key); });
    }, [_containerTypeList]);
    var handleSelectAllInputValue = useCallback(function (event) {
        var _a, _b;
        (_b = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.select) === null || _b === void 0 ? void 0 : _b.call(_a);
    }, []);
    useEffect(function () {
        if (!visible)
            return;
        // Determine initial pack-into mode
        var initialMode = selectedContainerId ? 'existing' : 'new';
        setPackIntoMode(initialMode);
        var prefill = pendingPrefill.current;
        pendingPrefill.current = null;
        form.setFieldsValue({
            productId: (prefill === null || prefill === void 0 ? void 0 : prefill.scanId) || '',
            numberOfContainers: 1,
            quantityPerContainer: (prefill === null || prefill === void 0 ? void 0 : prefill.quantity) || 1,
            containerTypeEnumId: 'CtCarton',
            packIntoContainerId: selectedContainerId || undefined,
        });
        var timerId = window.setTimeout(function () {
            var _a, _b, _c;
            var inputElement = ((_a = scanInputRef.current) === null || _a === void 0 ? void 0 : _a.input) || scanInputRef.current;
            (_b = inputElement === null || inputElement === void 0 ? void 0 : inputElement.focus) === null || _b === void 0 ? void 0 : _b.call(inputElement);
            (_c = inputElement === null || inputElement === void 0 ? void 0 : inputElement.select) === null || _c === void 0 ? void 0 : _c.call(inputElement);
        }, 0);
        return function () { return window.clearTimeout(timerId); };
    }, [form, visible, selectedContainerId]);
    var handleSubmit = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var values, params, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isConfirmLoading)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    setIsSubmitting(true);
                    return [4 /*yield*/, form.validateFields()];
                case 2:
                    values = _a.sent();
                    params = {
                        scanInput: String(values.productId || '').trim(),
                        numberOfContainers: Math.max(1, Number(values.numberOfContainers || 1)),
                        quantityPerContainer: Math.max(1, Number(values.quantityPerContainer || 1)),
                        containerTypeEnumId: values.containerTypeEnumId || undefined,
                        packIntoContainerId: form.getFieldValue('packIntoContainerId')
                    };
                    if (packIntoMode === 'existing' && params.packIntoContainerId) {
                        // do nothing
                    }
                    else if (packIntoMode === 'new') {
                        params.createPackIntoContainer = true;
                        params.packIntoContainerTypeEnumId = params.packIntoContainerTypeEnumId || 'CtPallet';
                    }
                    else {
                        // Fail in edge case where mode=existing and packIntoContainerId is not set
                        throw new Error('Internal Error');
                    }
                    return [4 /*yield*/, onSubmit(params)];
                case 3:
                    _a.sent();
                    form.resetFields();
                    onClose();
                    return [3 /*break*/, 6];
                case 4:
                    e_1 = _a.sent();
                    console.error(e_1);
                    return [3 /*break*/, 6];
                case 5:
                    setIsSubmitting(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); }, [form, isConfirmLoading, onSubmit, onClose, packIntoMode]);
    return (_jsx(Modal, __assign({ title: t('Bulk Pack') + (selectedContainerId ? " into " + selectedContainerId : ''), visible: visible, onCancel: function () {
            if (isConfirmLoading)
                return;
            onClose();
        }, onOk: handleSubmit, okText: t('Pack'), confirmLoading: isConfirmLoading, cancelButtonProps: { disabled: isConfirmLoading }, maskClosable: !isConfirmLoading, keyboard: !isConfirmLoading }, { children: _jsxs(Form, __assign({ form: form, layout: 'vertical' }, { children: [_jsx(Form.Item, __assign({ name: 'productId', label: t('Product ID / SKU'), rules: [
                        { required: true, message: t('Please enter a product ID') },
                        { pattern: /^(?!\s*$).+/, message: t('Please enter a product ID') }
                    ] }, { children: _jsx(Input, { ref: scanInputRef, title: '', placeholder: t('Scan or enter product ID'), autoFocus: true, onFocus: handleSelectAllInputValue, onClick: handleSelectAllInputValue }, void 0) }), void 0), _jsx(Form.Item, __assign({ name: 'containerTypeEnumId', label: t('Container Type') }, { children: _jsx(Dropdown, { searchable: true, placeholder: t('Select type'), data: containerTypeList }, void 0) }), void 0), _jsx(Form.Item, __assign({ name: 'numberOfContainers', label: t('# of Containers'), rules: [
                        { required: true, message: t('Please enter number of containers') },
                        { pattern: /^[1-9]\d*$/, message: t('Enter a valid count') }
                    ] }, { children: _jsx(Input, { title: '', inputType: 'number', placeholder: '1', onFocus: handleSelectAllInputValue, onClick: handleSelectAllInputValue }, void 0) }), void 0), _jsx(Form.Item, __assign({ name: 'quantityPerContainer', label: t('Quantity per Container'), rules: [
                        { required: true, message: t('Please enter quantity per container') },
                        { pattern: /^[1-9]\d*$/, message: t('Enter a valid quantity') }
                    ] }, { children: _jsx(Input, { title: '', inputType: 'number', placeholder: '1', onFocus: handleSelectAllInputValue, onClick: handleSelectAllInputValue }, void 0) }), void 0)] }), void 0) }), void 0));
});
export default BulkContainerModal;
